import {
  BACKGROUND_TEXT_MODE,
  TEXT_SHADOW_STYLE,
  TEXT_SHADOW_TARGET,
} from '../../constants';
import { hasTextBoxBackdrop } from './getTextBoxBackdropStyles';

function normalizeNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function toCssLength(value, converter) {
  const convertedValue = converter(value);
  return typeof convertedValue === 'number'
    ? `${convertedValue}px`
    : convertedValue;
}

export function normalizeTextShadowTarget(value) {
  return value === TEXT_SHADOW_TARGET.TEXT_BOX
    ? TEXT_SHADOW_TARGET.TEXT_BOX
    : TEXT_SHADOW_TARGET.TEXT;
}

export function hasVisibleTextBox(element) {
  return (
    element?.backgroundTextMode === BACKGROUND_TEXT_MODE.FILL ||
    element?.backgroundTextMode === BACKGROUND_TEXT_MODE.HIGHLIGHT ||
    hasTextBoxBackdrop(element)
  );
}

export function getEffectiveTextShadowTarget(element) {
  const target = normalizeTextShadowTarget(element?.shadowTarget);
  return target === TEXT_SHADOW_TARGET.TEXT_BOX && hasVisibleTextBox(element)
    ? TEXT_SHADOW_TARGET.TEXT_BOX
    : TEXT_SHADOW_TARGET.TEXT;
}

export function getNormalizedTextShadow(element) {
  if (element?.textShadowStyle !== TEXT_SHADOW_STYLE.DROP_SHADOW) {
    return null;
  }

  const color = element.textShadowColor?.color || {};
  return {
    target: getEffectiveTextShadowTarget(element),
    x: normalizeNumber(element.textShadowX),
    y: normalizeNumber(element.textShadowY),
    blur: normalizeNumber(element.textShadowBlur),
    color: {
      r: normalizeNumber(color.r),
      g: normalizeNumber(color.g),
      b: normalizeNumber(color.b),
      a: color.a ?? 1,
    },
  };
}

export function shouldApplyFillTextBoxShadow({
  element,
  backgroundTextMode = element?.backgroundTextMode,
  hasTextBoxBackdrop: hasBackdrop = false,
}) {
  if (hasBackdrop || backgroundTextMode !== BACKGROUND_TEXT_MODE.FILL) {
    return false;
  }

  return (
    getNormalizedTextShadow({ ...element, backgroundTextMode })?.target ===
    TEXT_SHADOW_TARGET.TEXT_BOX
  );
}

export function getTextShadowStyles({
  element,
  dataToStyleX = (value) => value,
  dataToStyleY = (value) => value,
}) {
  const shadow = getNormalizedTextShadow(element);
  if (!shadow) {
    return {};
  }

  const value = `rgba(${shadow.color.r}, ${shadow.color.g}, ${
    shadow.color.b
  }, ${shadow.color.a}) ${toCssLength(shadow.x, dataToStyleX)} ${toCssLength(
    shadow.y,
    dataToStyleY
  )} ${toCssLength(shadow.blur, dataToStyleY)}`;

  return shadow.target === TEXT_SHADOW_TARGET.TEXT_BOX
    ? { boxShadow: value }
    : { textShadow: value };
}
